import Close from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import LinearProgress from '@mui/material/LinearProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
export const Modal = ({ title, subTitle, isOpen, onClose, disableClose, isLoading, children, actions, withCancelButton = true, cancelLabel = 'Cancel', fullWidth = false, maxWidth = 'sm', ContentProps, ...rest }) => {
    return (<Dialog open={isOpen} onClose={!disableClose ? onClose : undefined} fullWidth={fullWidth} maxWidth={maxWidth} {...rest}>
			<DialogTitle>
				<Stack>
					{title}
					{subTitle && <Typography variant='caption'>{subTitle}</Typography>}
				</Stack>
			</DialogTitle>
			<IconButton disabled={disableClose || isLoading} onClick={onClose} size='small' aria-haspopup='true' sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500],
        }}>
				<Close />
			</IconButton>
			<DialogContent sx={{ pt: 0, ...ContentProps?.sx }} {...ContentProps}>
				{children}
			</DialogContent>
			{isLoading && <LinearProgress variant='indeterminate' sx={{ height: 3, pb: actions || withCancelButton ? 0.4 : 0.7 }}/>}
			{(actions || withCancelButton) && (<>
					<Divider variant='fullWidth' orientation='horizontal'/>
					<DialogActions>
						{withCancelButton && (<Button variant='outlined' onClick={onClose} disabled={isLoading} sx={{ mr: 1 }} color='inherit'>
								{cancelLabel}
							</Button>)}
						{actions}
					</DialogActions>
				</>)}
		</Dialog>);
};
//# sourceMappingURL=Modal.jsx.map